module.exports = __webpack_public_path__ + "assets/img/img31.4cf86edd.png";